module.exports = __webpack_public_path__ + "static/media/zs_nova_dubnica.3ff7ae83.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/zs_nova_dubnica.png
// module id = 499
// module chunks = 0